import { ThirdLicense } from "../Model/ThirdLicense";
export class ThirdLicenseService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async getThirdLicensByThirdId(thirdId) {
        if (thirdId) {
            const response = await this.apiService.get('thirdLicense/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener los permisos de conducir.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ThirdId.`);
        }
    }
    async removeThirdLicense(id, third_id) {
        if (id) {
            const response = await this.apiService.post('thirdLicense/remove/', { id, third_id });
            if (!response.ok) {
                throw new Error(`Error al eliminar el permiso de conducir.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener id.`);
        }
    }
    async saveThirdLicense(thirdLicense) {
        if (thirdLicense) {
            const response = await this.apiService.post('thirdLicense', thirdLicense instanceof ThirdLicense ? thirdLicense.getState() : thirdLicense);
            if (!response.ok) {
                throw new Error(`Error al guardar el permiso de conducir.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener thirdLicense.`);
        }
    }
}
